import login from './logIn.json';
import userCard from './userCard.json';
import dashboard from './dashboard.json';
import search from './search.json';
import contractList from './contractList.json';
import actsList from './actsList.json';
import terminationList from './terminationList.json';
import adminPanel from './adminPanel.json';
import insuredEventsList from './insuredEventsList.json';
import registrationDevices from './registrationDevices.json';
import sideMenu from './sideMenu.json';
import settings from './settings.json';
import usersActivities from './usersActivities.json';
import insuranceContracts from './insuranceContracts.json';
import departments from './departments.json';
import insuranceProgramList from './insuranceProgramList.json';
import departmentDetails from './departmentDetails.json';
import insuranceCompanies from './insuranceCompanies.json';
import insuranceConfiguration from './insuranceConfiguration.json';
import brandsPage from './brandsPage.json';
import partnerList from './partnerList.json';
import partnerCreation from './partnerCreation.json';
import table from './table.json';
import breadcrumbs from './breadcrumbs.json';
import noData from './noData.json';
import curtomerInfo from './curtomerInfo.json';
import contractDetails from './contractDetails.json';
import signup from './signup.json';
import sellerDashboard from './sellerDashboard.json';
import detailsCard from './detailsCard.json';
import generalInfo from './generalInfo.json';
import purchaseInfo from './purchaseInfo.json';
import passwordRecovery from './passwordRecovery.json';
import personInfo from './personInfo.json';
import carInfo from './carInfo.json';
import jutloInfo from './jutloInfo.json';
import actCreate from './actCreate.json';
import errorPage from './errorPage.json';
import actDetails from './actDetails.json';
import form from './form.json';
import modal from './modal.json';
import searchResult from './searchResult.json';
import documentsTable from './documentsTable.json';
import insurance from './insurance.json';
import clientSign from './clientSign.json';
import insuranceProgramDetails from './insuranceProgramDetails.json';
import insuredEvents from './insuredEvents.json';
import terminationDetails from './terminationDetails.json';
import popup from './popup.json';
import validation from './validation.json';
import status from './status.json';
import constants from './constants.json';
import chats from './chats.json';
import doctor from './doctor.json';
import consultations from './consultations.json';
import appointments from './appointments.json';
import history from './history.json';
import medapp from './medApp.json';
import registerOfTypes from './registerOfTypes.json';
import sublimits from './sublimits.json';
import deviceType from './deviceType.json';
import enums from './enums.json';
import services from './services.json';
import schema from './schema.json';
import dashboard_extend from './dashboard_extend.json';

export const UA_TRANSLATIONS = {
  ...login,
  ...chats,
  ...userCard,
  ...dashboard,
  ...search,
  ...contractList,
  ...actsList,
  ...terminationList,
  ...adminPanel,
  ...insuredEventsList,
  ...registrationDevices,
  ...sideMenu,
  ...settings,
  ...usersActivities,
  ...insuranceContracts,
  ...departments,
  ...insuranceProgramList,
  ...departmentDetails,
  ...insuranceCompanies,
  ...insuranceConfiguration,
  ...brandsPage,
  ...partnerList,
  ...partnerCreation,
  ...table,
  ...breadcrumbs,
  ...noData,
  ...curtomerInfo,
  ...contractDetails,
  ...signup,
  ...sellerDashboard,
  ...detailsCard,
  ...generalInfo,
  ...purchaseInfo,
  ...passwordRecovery,
  ...personInfo,
  ...carInfo,
  ...jutloInfo,
  ...actCreate,
  ...errorPage,
  ...actDetails,
  ...form,
  ...modal,
  ...searchResult,
  ...documentsTable,
  ...insurance,
  ...clientSign,
  ...insuranceProgramDetails,
  ...insuredEvents,
  ...terminationDetails,
  ...popup,
  ...validation,
  ...status,
  ...constants,
  ...doctor,
  ...consultations,
  ...appointments,
  ...history,
  ...medapp,
  ...registerOfTypes,
  ...sublimits,
  ...deviceType,
  ...enums,
  ...services,
  ...schema,
  ...dashboard_extend,
};
